import riderImg from '../../assets/images/ride.png';

const requirements = [
  {
    title: 'Valid ID and Background Check',
    description:
      'Provide a government-issued ID and pass a quick background check to ensure safety for everyone.',
  },
  {
    title: 'Smartphone with Internet Access',
    description:
      "You'll need an Android or iOS device to access the Speedyssey Driver App, accept orders, and navigate routes.",
  },
  {
    title: 'A Delivery Vehicle',
    description:
      'Use your own car, bike, or scooter or get connected with a Speedyssey partner if you need one.',
  },
  {
    title: 'Bank Account',
    description:
      'Set up your bank to receive earnings fast and without hassle.',
  },
];

function GetStarted() {
  return (
    <section id="requirements" className="container mx-auto px-6 lg:px-12 py-16 lg:py-24">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
        {/* Requirements List */}
        <div className="space-y-6 order-2 lg:order-1">
          <div>
            <h2 className="text-2xl md:text-4xl font-bold mb-2">
              What you need to get started
            </h2>
            <p className="text-gray-700 md:text-lg">
              Delivering with Speedyssey is simple. Just meet these basic requirements and you're good to go.
            </p>
          </div>

          <ul className="space-y-5">
            {requirements.map((req) => (
              <li key={req.title} className="flex items-start gap-4">
                <span className="mt-1 w-2 h-2 rounded-full bg-[#F55109] shrink-0" />
                <div>
                  <h3 className="font-semibold text-base md:text-lg mb-1">
                    {req.title}
                  </h3>
                  <p className="text-gray-600 text-sm md:text-base leading-relaxed">
                    {req.description}
                  </p>
                </div>
              </li>
            ))}
          </ul>
        </div>

        {/* Image */}
        <div className="order-1 lg:order-2 flex justify-center lg:justify-end">
          <img
            src={riderImg}
            alt="Delivery Rider"
            className="rounded-xl object-cover w-full max-w-lg lg:max-w-lg xl:max-w-xl"
            style={{ minHeight: '350px', maxHeight: '520px' }}
          />
        </div>
      </div>
    </section>
  );
}

export default GetStarted;
